import OrganizationUser from "@/pages/medewerkers/$organizationUserId/gegevens/OrganizationUser"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/medewerkers/$organizationUserId/gegevens/",
)({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "contacts"),
})

function RouteComponent() {
  const { organizationUserId } = useParams({
    from: "/beheer/medewerkers/$organizationUserId",
  })

  return <OrganizationUser organizationUserId={Number(organizationUserId)} />
}
